import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { RegionRule } from '../../../models/feature-flag.model';
import { AbstractListRuleComponent } from './abstract-list-rule.component';

/**
 * Component for building and managing region-based targeting rules
 */
@Component({
  selector: 'cbre-region-rule',
  templateUrl: './region-rule.component.html',
  styleUrls: ['./region-rule.component.scss'],
  standalone: false,
})
export class RegionRuleComponent extends AbstractListRuleComponent<RegionRule> {
  /**
   * The rule type identifier
   */
  protected ruleType = 'region';

  /**
   * Common regions for quick selection
   * This could be expanded or loaded from configuration
   */
  protected commonItems = ['United States of America', 'Canada', 'Mexico'];

  /**
   * Error message for duplicates
   */
  protected duplicateErrorMessage = 'This region is already in the list';

  constructor(protected override fb: FormBuilder) {
    super(fb);
  }
}
